const Premium = ({ isClient }) => {
    if (!isClient) {
        return <div className='premium'>
            <img src={'./static/subscription/crown.svg'} />
        </div>;
    } else return null;
}
export default Premium;
